import { fetcher } from "helpers/fetcher";

import { TCreateTagReq, TCreateTagRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const createTag = async (payload: TCreateTagReq) => {
  return await fetcher<TCreateTagRes, TCreateTagReq["data"]>(
    ENDPOINT.MANAGEMENT.CREATE_TAG,
    {
      data: payload.data,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.MANAGEMENT.CREATE_TAG.version,
        [API_HEADER.BU_ID]: payload.idBu,
      },
    }
  );
};

export const mutationCreateTag = async (payload: TCreateTagReq) => {
  return (await createTag(payload)).data;
};

mutationCreateTag._key = (payload: TCreateTagReq) => [
  ENDPOINT.MANAGEMENT.CREATE_TAG.url,
  payload,
];
